define([
    'text!product-detail/component/images-box.html',
    'common/component/image-slick'
], function(
    tpl,
    ImageSlick
){
    return {
        template: tpl,
        components: {
            ImageSlick: ImageSlick
        },
        props: {
            images: {
                type: Array
            },
            options: {
                type: Object
            }
        },
        computed: {
            image: function(){
                // console.log(this.images[0]);
                return this.images[0] || '';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/images-box.js
// module id = 113
// module chunks = 0